import { render, staticRenderFns } from "./BranchMap.vue?vue&type=template&id=2616bcbd&scoped=true&"
import script from "./BranchMap.vue?vue&type=script&lang=js&"
export * from "./BranchMap.vue?vue&type=script&lang=js&"
import style0 from "./BranchMap.vue?vue&type=style&index=0&id=2616bcbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2616bcbd",
  null
  
)

export default component.exports